export default __webpack_public_path__ + "static/media/83.d1e7dd66.png";